export interface IExamManagementNotificationLog {
  id: string;
  description: string;
  created: string;
}
export interface IExamManagementNotification {
  id: string;
  integrationRuleId: string;
  integrationRuleNotificationId: string;
  sequencialControl: number;
  physicianIdentifier?: string;
  physicianName?: string;
  patientEncounterNumber?: number;
  status: string;
  examManagementPayload?: string;
  reportLiberationDate?: string;
  sentDate?: string;
  errorMessage?: string;
  created: string;
}
export interface IExamManagementNotificationDetails extends IExamManagementNotification {
  logs: IExamManagementNotificationLog[];
}

export const getPhysicianDisplay = (
  notification: IExamManagementNotification,
) =>
  notification.physicianName
    ? `${notification.physicianName} (${notification.physicianIdentifier || "-"})`
    : notification.physicianIdentifier || "-";
